var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c("el-form", {
    attrs: {
      inline: true
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "服务器列表",
      "label-width": "100px"
    }
  }, [_c("server-list", {
    attrs: {
      isCache: "",
      multiple: true,
      all: ""
    },
    model: {
      value: _vm.searchInfo.server_id,
      callback: function callback($$v) {
        _vm.$set(_vm.searchInfo, "server_id", $$v);
      },
      expression: "searchInfo.server_id"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "工会ID：",
      "label-width": "80px"
    }
  }, [[_c("el-input", {
    staticStyle: {
      width: "180px",
      height: "38px"
    },
    model: {
      value: _vm.searchInfo.union_id,
      callback: function callback($$v) {
        _vm.$set(_vm.searchInfo, "union_id", $$v);
      },
      expression: "searchInfo.union_id"
    }
  })]], 2), _c("el-form-item", {
    attrs: {
      label: "工会名称：",
      "label-width": "100px"
    }
  }, [[_c("el-input", {
    staticStyle: {
      width: "180px",
      height: "38px"
    },
    model: {
      value: _vm.searchInfo.union_name,
      callback: function callback($$v) {
        _vm.$set(_vm.searchInfo, "union_name", $$v);
      },
      expression: "searchInfo.union_name"
    }
  })]], 2), _c("el-form-item", [[_c("el-button", {
    attrs: {
      type: "primary"
    },
    on: {
      click: function click($event) {
        return _vm.queryEvent();
      }
    }
  }, [_vm._v("查询")])]], 2)], 1)], 1), _c("div", [_c("el-table", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      data: _vm.tableData,
      border: "",
      "row-key": "authorityId",
      stripe: ""
    }
  }, [_c("el-table-column", {
    attrs: {
      label: "序号",
      width: "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("span", [_vm._v(_vm._s(scope.$index + 1 + (_vm.page - 1) * _vm.pageSize) + " ")])];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "工会id",
      prop: "unionId"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "工会名称",
      prop: "unionName"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "工会等级",
      prop: "unionLevel"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "工会会长角色ID",
      prop: "unionMasterId"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "工会所在服务器ID",
      prop: "serverId"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "最后更新时间",
      prop: "lastUpdateTime"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "是否解散"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm._v(" " + _vm._s(scope.row.unionIsDismiss == 0 ? "未解散" : "已解散") + " ")];
      }
    }])
  }), _c("el-table-column", {
    attrs: {
      label: "工会公告",
      prop: "unionNotice"
    }
  }), _c("el-table-column", {
    attrs: {
      label: "工会用户数",
      prop: "unionUserCnt"
    }
  }), _c("el-table-column", {
    staticStyle: {
      "z-index": "index 0"
    },
    attrs: {
      fixed: "right",
      label: "操作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c("el-button", {
          attrs: {
            icon: "el-icon-edit",
            size: "small",
            type: "primary"
          },
          on: {
            click: function click($event) {
              return _vm.EditUnionBtn(scope.row);
            }
          }
        }, [_vm._v(" 编辑 ")])];
      }
    }])
  })], 1)], 1), _c("el-pagination", {
    style: {
      float: "right",
      padding: "20px"
    },
    attrs: {
      "current-page": _vm.page,
      "page-size": _vm.pageSize,
      "page-sizes": [5, 30, 50, 100, 500],
      total: _vm.total,
      layout: "total, sizes, prev, pager, next, jumper"
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange
    }
  }), _c("div", [_vm.dialogFormVisible ? _c("el-dialog", {
    staticStyle: {
      height: "500px"
    },
    attrs: {
      title: "工会 列表",
      width: "30%",
      visible: _vm.dialogFormVisible,
      center: ""
    },
    on: {
      "update:visible": function updateVisible($event) {
        _vm.dialogFormVisible = $event;
      }
    }
  }, [_c("show-union-msg", {
    attrs: {
      formData: _vm.formData
    },
    on: {
      backMsg: _vm.backMsg
    }
  })], 1) : _vm._e()], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };